import React from 'react';

export interface RestoreLoadingOverlayProps {
  isOpen: boolean;
  // "ダウンロード中" "展開中" "保存中" 等の動的ステップ表示 (任意、 v1 では未使用 — 将来拡張)。
  step?: string;
  // エラー発生時の表示 (任意、 出すと spinner → エラーアイコンに切替)。
  error?: string | null;
  // エラー時の閉じるボタン (任意)。
  onDismissError?: () => void;
}

// issue #24 UX Group B: Drive 履歴復元中に画面全体を覆い操作不可にする overlay。
// DriveHistoryModal (z-50) / OverwriteConfirmModal (z-50) より高い z-[60] で完全に被せる。
const RestoreLoadingOverlay: React.FC<RestoreLoadingOverlayProps> = ({
  isOpen, step, error, onDismissError,
}) => {
  if (!isOpen) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="復元中"
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60"
    >
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-xs w-full text-center mx-4">
        {error ? (
          <>
            <div className="text-red-600 text-3xl mb-3" aria-hidden="true">⚠️</div>
            <p className="font-bold text-slate-800 mb-2" aria-live="assertive">復元に失敗しました</p>
            <p className="text-sm text-slate-600 mb-4">{error}</p>
            <button
              type="button"
              onClick={onDismissError}
              className="px-4 py-2 rounded-lg bg-slate-600 text-white text-sm hover:bg-slate-700"
            >
              閉じる
            </button>
          </>
        ) : (
          <>
            <div
              className="animate-spin w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full mx-auto mb-3"
              aria-hidden="true"
            />
            <p className="font-bold text-slate-800">復元中…</p>
            {step && <p className="text-xs text-slate-500 mt-1">{step}</p>}
          </>
        )}
      </div>
    </div>
  );
};

export default RestoreLoadingOverlay;
